<template>
    <div class="home">
        <el-container class="root">
            <el-aside class="leftNav" :style="{ width: isSidebarCollapsed ? '0.45rem' : '1.3021rem' }">
                <div class="nav-container">
                    <!-- 固定头部logo区域 -->
                    <div class="titleHead fixed-header">
                        <img src="/static/images/topicon.png" alt="" class="header-logo"
                            :class="{ 'collapsed-logo': isSidebarCollapsed }" />
                        <!-- 添加的折叠按钮 -->
                        <button class="collapse-btn" @click="toggleSidebar">
                            <i :class="isSidebarCollapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
                        </button>
                        <span v-if="!isSidebarCollapsed" style="color: #fff;" class="normolFont"></span>
                        <span v-if="!isSidebarCollapsed" style="color: #fff;" class="normolFont"></span>
                    </div>

                    <!-- 可滚动的菜单区域 -->
                    <div class="scrollable-menu">
                        <!-- 分组菜单 -->
                        <div v-for="(group, groupIndex) in menuGroups" :key="'group-' + groupIndex" class="menu-group">
                            <!-- 分组标题 -->
                            <div class="menu-group-title" v-show="!isSidebarCollapsed">{{ group.title }}</div>

                            <!-- 分组菜单项 -->
                            <div class="menu1">
                                <button :class="$route.path === item.path ? 'menuItem-active' : 'menuItem'"
                                    v-for="item in group.items" v-bind:key="item.id" @click="goto(item)">
                                    <div class="menuContent">
                                        <img :src="$route.path === item.path ? item.imgPathXz : item.imgPath"
                                            class="menu-icon" />
                                        <span class="menu-text" :class="{ 'active-text': $route.path === item.path }"
                                            v-show="!isSidebarCollapsed">
                                            {{ item.name }}
                                        </span>
                                        <img src="/static/images/bate.png" class="betaIcon"
                                            v-show="item.name == 'AI转矢量' && !isSidebarCollapsed" />
                                    </div>
                                </button>
                            </div>
                        </div>

                        <div class="menu1" v-if="false">
                            <button class="menuItem" @click="goSvg">
                                <div class="menuContent">
                                    <img src="/static/images/svg.png" class="menu-icon" />
                                    <span class="menu-text">AI转矢量</span>
                                </div>
                                <img src="/static/images/bate.png" class="betaIcon" />
                            </button>
                        </div>
                    </div>
                </div>
            </el-aside>
            <el-container class="mainInfo">
                <el-header class="headApp" style="height: 0.4688rem;">
                    <div class="headLL">
                        <div v-if="productType"
                            style="color: #03aff4; font-size: 0.0833rem;display: flex;align-items: center;line-height:0.0933rem ;">
                            <div style="color: #e8e8e8">剩余算力:</div>
                            {{ lastCount }}
                        </div>
                        <div v-if="isShowRestPass && isShowRestPass.length > 0">
                            <template>
                                <el-popconfirm title="确认退出登录么 " @confirm="logOut">
                                    <button class="headLoginBtn" slot="reference">
                                        <img src="/static/images/tuichudenglu.png" alt="" />
                                        <span style="color: #fff;" class="bigFont">退出登录</span>
                                    </button>
                                </el-popconfirm>
                            </template>
                        </div>
                        <div v-else>
                            <button class="headLoginBtn" @click="showLogin">
                                <img src="/static/images/pc_head.png" alt="" />
                                <span style="color: #fff;" class="bigFont">{{ loginTip }}</span>
                            </button>
                        </div>

                        <button class="headLoginBtn" @click="resetPass"
                            v-show="isShowRestPass && isShowRestPass.length > 0">
                            <img src="/static/images/xiugaimima.png" alt="" />
                            <span style="color: #fff;" class="bigFont">修改密码</span>
                        </button>
                    </div>
                </el-header>
                <router-view />
            </el-container>
        </el-container>
    </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import bus from "@/utils/bus";
import store from "../../store";
import { getUserRight, getUserLimit } from "@/api/user/userChatTitle";
export default {
    name: "Home",
    data() {
        return {
            // 添加折叠状态变量
            isSidebarCollapsed: false,
            // 原始菜单列表（现在只用于初始化）
            list: [
                {
                    name: "个人首页",
                    imgPath: "/static/images/gerenshouye.png",
                    imgPathXz: "/static/images/gerenshouye_s.png",
                    path: "/welcome"
                },
                {
                    name: "爆款生成",
                    imgPath: "/static/images/zhinengwenda.png",
                    imgPathXz: "/static/images/zhinengwenda_s.png",
                    path: "/build"
                },
                {
                    name: "爆款融合",
                    imgPath: "/static/images/aihuihua.png",
                    imgPathXz: "/static/images/aihuihua_s.png",
                    path: "/picbuild"
                },
                {
                    name: "爆点提取",
                    imgPath: "/static/images/picbuild.png",
                    imgPathXz: "/static/images/picbuild_s.png",
                    path: "/pic2text"
                },
                // {
                //   name: "我的权限",
                //   imgPath: "/static/images/gongzuomoshi.png",
                //   imgPathXz: "/static/images/gongzuomoshi_s.png",
                //   path: "/mypro"
                // },
                {
                    name: "我的作品",
                    imgPath: "/static/images/shenghuomoshi.png",
                    imgPathXz: "/static/images/shenghuomoshi_s.png",
                    path: "/mywork"
                },
                {
                    name: "AI转矢量",
                    imgPath: "/static/images/svg.png",
                    imgPathXz: "/static/images/svg_s.png",
                    path: "/svg"
                }
            ],

            // 分组菜单数据
            menuGroups: [
                {
                    title: "个人中心",
                    items: []
                },
                {
                    title: "原创设计",
                    items: []
                },
                {
                    title: "营销工具",
                    items: []
                },
                {
                    title: "辅助工具",
                    items: []
                }
            ],

            loginTip: getToken() ? "已登录" : "点击登录",
            lastCount: 100,
            productType: undefined,
            isShowRestPass: store.state.token
        };
    },
    created() {
        bus.$on("loginSucess", call => {
            this.loginTip = "已登录";
            this.isShowRestPass = store.state.token;
            // 此处添加是否需要动态路由处理
            this.changeMenu();
            this.resetProductInfo();
        });
        bus.$on("refreshCount", call => {
            // 处理更新剩余算力
            getUserLimit().then(res => {
                this.lastCount = res.data.remainingTimes;
            });
        });

        // 初始化菜单分组
        this.initMenuGroups();
    },
    beforeDestroy() {
        bus.$off("loginSucess");
        bus.$off("refreshCount");
    },

    mounted() {
        if (getToken()) {
            this.changeMenu();
            this.resetProductInfo();
        }
    },
    methods: {
        // 添加折叠侧边栏方法
        toggleSidebar() {
            this.isSidebarCollapsed = !this.isSidebarCollapsed;
        },
        // 初始化菜单分组
        initMenuGroups() {
            // 基础功能组
            this.menuGroups[0].items = [
                {
                    name: "个人首页",
                    imgPath: "/static/images/gerenshouye.png",
                    imgPathXz: "/static/images/gerenshouye_s.png",
                    path: "/welcome"
                }
            ];

            // 内容创作组
            this.menuGroups[1].items = [
                {
                    name: "爆款生成",
                    imgPath: "/static/images/zhinengwenda.png",
                    imgPathXz: "/static/images/zhinengwenda_s.png",
                    path: "/build"
                },
                {
                    name: "爆款融合",
                    imgPath: "/static/images/aihuihua.png",
                    imgPathXz: "/static/images/aihuihua_s.png",
                    path: "/picbuild"
                },
                {
                    name: "爆点提取",
                    imgPath: "/static/images/picbuild.png",
                    imgPathXz: "/static/images/picbuild_s.png",
                    path: "/pic2text"
                }
            ];

            // 图像处理组
            this.menuGroups[3].items = [
                {
                    name: "AI转矢量",
                    imgPath: "/static/images/svg.png",
                    imgPathXz: "/static/images/svg_s.png",
                    path: "/svg"
                }
            ];

            // 个人中心组
            this.menuGroups[0].items = [
                {
                    name: "我的作品",
                    imgPath: "/static/images/shenghuomoshi.png",
                    imgPathXz: "/static/images/shenghuomoshi_s.png",
                    path: "/mywork"
                }
            ];
        },

        resetProductInfo() {
            getUserLimit().then(res => {
                if (res.data.productType != 0) {
                    this.productType = res.data.productType;
                    localStorage.setItem("FrequencyLimit", true);
                    this.lastCount = res.data.remainingTimes;
                } else {
                }
            });
        },
        changeMenu() {
            getUserRight().then(res => {
                const actionList = res.data.actions.split(",");

                // 重置分组菜单
                this.initMenuGroups();

                // 图像处理工具数组
                const imageProcessingTools = [];
                const yingxiaoTools = [];
                const grzxTools = [];
                const ycsjTools = [];

                if (
                    actionList.indexOf("LINETOIMAGE") > -1 ||
                    actionList.indexOf("IMAGETOLINE") > -1
                ) {
                    ycsjTools.push({
                        name: "线稿生图",
                        imgPath: "/static/images/xiangao.png",
                        imgPathXz: "/static/images/xiangao_s.png",
                        path: "/scriptBuild"
                    });
                }
                if (actionList.indexOf("HDZOOM") > -1) {
                    imageProcessingTools.push({
                        name: "智能放大",
                        imgPath: "/static/images/hdzoom.png",
                        imgPathXz: "/static/images/hdzoom_s.png",
                        path: "/hdzoom"
                    });
                }

                if (actionList.indexOf("RECOLOR") > -1) {
                    imageProcessingTools.push({
                        name: "配色延伸",
                        imgPath: "/static/images/tab_recolor_n.png",
                        imgPathXz: "/static/images/tab_recolor_s.png",
                        path: "/recolor"
                    });
                }
                if (actionList.indexOf("DIRECTRECOLOR") > -1) {
                    imageProcessingTools.push({
                        name: "定向改色",
                        imgPath: "/static/images/scriptpic.png",
                        imgPathXz: "/static/images/scriptpic_s.png",
                        path: "/colorfit"
                    });
                }
                if (actionList.indexOf("CHANGEFACE") > -1) {
                    yingxiaoTools.push({
                        name: "定向换脸",
                        imgPathXz: "/static/images/face_s.png",
                        imgPath: "/static/images/face_n.png",
                        path: "/faceChange"
                    });
                }
                if (actionList.indexOf("PARTPAINT") > -1) {
                    yingxiaoTools.push({
                        name: "局部修改",
                        imgPathXz: "/static/images/inpaint_f.png",
                        imgPath: "/static/images/inpaint.png",
                        path: "/areaInpaint"
                    });
                }
                if (actionList.indexOf("STYLEUP") > -1) {
                    yingxiaoTools.push({
                        name: "款式上身",
                        imgPathXz: "/static/images/stylefix_f.png",
                        imgPath: "/static/images/stylefix.png",
                        path: "/upperbody"
                    });
                }


                yingxiaoTools.push({
                    name: "款式上身",
                    imgPathXz: "/static/images/stylefix_f.png",
                    imgPath: "/static/images/stylefix.png",
                    path: "/styleprev"
                });

                if (actionList.indexOf("STYLEUPFIX") > -1) {
                    yingxiaoTools.push({
                        name: "款式上身",
                        imgPathXz: "/static/images/stylefix_f.png",
                        imgPath: "/static/images/stylefix.png",
                        path: "/upperbodyFix"
                    });
                }
                if (actionList.indexOf("FABRICPREVIEW") > -1) {
                    yingxiaoTools.push({
                        name: "面料上身",
                        imgPath: "/static/images/mianliao_n.png",
                        imgPathXz: "/static/images/mianliao_f.png",
                        path: "/fabricPreview"
                    });
                }
                if (actionList.indexOf("CHANGEBACKGROUND") > -1) {
                    yingxiaoTools.push({
                        name: "模特换背景",
                        imgPathXz: "/static/images/modelbg_f.png",
                        imgPath: "/static/images/modelbg.png",
                        path: "/changebackground"
                    });
                }
                if (actionList.indexOf("MATERIAL") > -1) {
                    yingxiaoTools.push({
                        name: "材质替换",
                        imgPathXz: "/static/images/modelbg_f.png",
                        imgPath: "/static/images/modelbg.png",
                        path: "/materialupper"
                    });
                }

                if (actionList.indexOf("IMAGECHANGE") > -1) {
                    yingxiaoTools.push({
                        name: "AI换装",
                        imgPath: "/static/images/aichange.png",
                        imgPathXz: "/static/images/aichange_s.png",
                        path: "/aichange"
                    });
                }
                if (actionList.indexOf("AIMATTING") > -1) {
                    imageProcessingTools.push({
                        name: "AI褪底",
                        imgPath: "/static/images/aimatting.png",
                        imgPathXz: "/static/images/aimatting_s.png",
                        path: "/aimatting"
                    });
                }

                // 将图像处理工具添加到图像处理分组
                if (imageProcessingTools.length > 0) {
                    this.menuGroups[3].items = [...this.menuGroups[3].items, ...imageProcessingTools];
                }
                if (yingxiaoTools.length > 0) {
                    this.menuGroups[2].items = [...this.menuGroups[2].items, ...yingxiaoTools];
                }
                if (ycsjTools.length > 0) {
                    this.menuGroups[1].items = [...this.menuGroups[1].items, ...ycsjTools];
                }


                // 个人中心菜单项
                const personalItems = [


                    {
                        name: "个人首页",
                        imgPath: "/static/images/gerenshouye.png",
                        imgPathXz: "/static/images/gerenshouye_s.png",
                        path: "/welcome"
                    },
                    {
                        name: "案例广场",
                        imgPath: "/static/images/casesquare.png",
                        imgPathXz: "/static/images/casesquare_s.png",
                        path: "/caseSquare"
                    }
                ];

                // 将个人中心菜单项添加到个人中心分组
                this.menuGroups[0].items = [...this.menuGroups[0].items, ...personalItems];

                // 过滤掉没有菜单项的分组
                this.menuGroups = this.menuGroups.filter(group => group.items.length > 0);
            });
        },

        goto(path) {
            if (this.$route.path != path.path) {
                this.currentMenu = path.name;
                this.$router.replace(path.path);
            }
        },
        showLogin() {
            if (!getToken()) {
                bus.$emit("showLogin");
            }
        },
        resetPass() {
            this.$emit("resetPass");
        },
        goSvg() {
            window.open(
                "https://pc.thinkin.ztxin.cn/static/ToSvg/index.html?token=" +
                getToken(),
                "blank"
            );
        },
        logOut() {
            store.dispatch("FedLogOut").then(() => {
                location.reload();
            });
        }
    },
    computed: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leftNav {
    width: 200px;
    height: 100%;
    background: #141825;
    background-size: 100% 100%;
    justify-content: center;
    position: relative;
    border-right: 1px solid #00000c;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    overflow: hidden;
}

/* 折叠按钮样式 */
.collapse-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 12px;
    transition: all 0.3s ease;
    z-index: 10;
}

.collapse-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.collapsed-logo {
    width: 40px;
    height: 40px;
    margin-top: 10px;
}

button {
    outline: none;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
}

.normolFont {
    font-size: 12px;
}

.bigFont {
    font-size: 15px;
}

/* 固定头部和滚动区域的容器 */
.nav-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* 固定的头部logo */
.fixed-header {
    padding-top: 30px;
    margin-bottom: 20px;
    flex-shrink: 0;
    /* 防止头部压缩 */
    position: relative;
}

.titleHead {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 头部logo图片缩小50% */
.header-logo {
    width: 83px;
    /* 原86px的50% */
    height: 89px;
    /* 原98px的50% */
    transition: all 0.3s ease;
}

/* 可滚动的菜单部分 */
.scrollable-menu {
    flex-grow: 1;
    overflow-y: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    padding-bottom: 30px;
}

.scrollable-menu::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

/* 菜单分组样式 */
.menu-group {
    width: 100%;
    margin-bottom: 15px;
}

/* 分组标题字体增大并调整颜色 */
.menu-group-title {
    color: #03aff4;
    /* 使用更醒目的蓝色 */
    font-size: 14px;
    /* 增大字体 */
    padding: 0 24px;
    margin-bottom: 10px;
    text-align: left;
    font-weight: 600;
    /* 增加字重 */
    letter-spacing: 0.5px;
    /* 增加字间距 */
}

.headLL {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
}

.headLoginBtn {
    display: flex;
    align-items: center;
    margin-left: 34px;
    color: #ffffff;
    transition: opacity 0.2s ease;
}

.headLoginBtn:hover {
    opacity: 0.8;
}

.betaIcon {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 15px;
}

.headLoginBtn img {
    width: 22px;
    height: 22px;
    margin-right: 6px;
}

/* 菜单内容布局 */
.menuContent {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 15px;
    position: relative;
    justify-content: center;
}

.menu-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.menu-text {
    margin-left: 12px;
    font-size: 14px;
    white-space: nowrap;
    text-align: left;
    flex-grow: 1;
    transition: color 0.2s ease;
}

/* 选中状态的文字颜色 */
.active-text {
    color: white;
    /* 白色文本与蓝色背景对比更明显 */
    font-weight: 500;
}

.menu1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* 新的菜单项样式 */
.menuItem {
    width: 90%;
    height: 48px;
    margin: 4px 0;
    display: flex;
    align-items: center;
    color: #e0e0e0;
    font-size: 14px;
    position: relative;
    transition: all 0.2s ease;
    border-radius: 6px;
}

.menuItem:hover {
    background-color: rgba(255, 255, 255, 0.08);
    color: #ffffff;
}

/* 菜单项悬停时文字变色 */
.menuItem:hover .menu-text {
    color: #ffffff;
}

/* 增强选中状态渐变色 */
.menuItem-active {
    width: 90%;
    height: 48px;
    margin: 4px 0;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.2s ease;
    border-radius: 6px;
    background: linear-gradient(to right, #0388f4, #03c2f4);
    /* 更醒目的渐变色 */
    box-shadow: 0 2px 10px rgba(3, 175, 244, 0.3);
    /* 增强阴影效果 */
}

.menuItem-active:before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 12px;
    width: 3px;
    background-color: white;
    /* 白色边条与蓝色背景对比更明显 */
    border-radius: 0 3px 3px 0;
}

.headApp {
    height: 100px;
    width: 100%;
    background: #141825;
    border: 0px solid #524587;
}

.home {
    width: 100%;
    height: 100%;
    font-size: 14px;
    position: relative;
}

.root {
    width: 100%;
    height: 100%;
}

.mainInfo {
    width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue